import store from "../store/store";
import { verifyLineAccessToken, lineLogin } from "@/services/lineApi.service";

// 回跳換 token 失敗（例：無痕分頁讀不到發起登入時的 PKCE）時，沿用原 state 重新登入一次；
// login_retry 跟著 state 回跳，避免無限重試
const getLoginRetryData = (state) => {
  try {
    const data = JSON.parse(state);
    if (
      !data ||
      typeof data !== "object" ||
      Array.isArray(data) ||
      data.login_retry
    ) {
      return null;
    }
    const retryData = { ...data, login_retry: 1 };
    delete retryData.csrf;
    return retryData;
  } catch (error) {
    return null;
  }
};

const homePageAuthGuard = async (to, from, next) => {
  try {
    store.commit("basic/setErrorLogin", { state: false, message: "" });
    console.log("to", to);
    console.log("from", from);
    const accessToken = store.getters["line/accessToken"];
    const lineLoginData = store.state.line.lineLoginData;

    //    // Modify By Bryant 2025041601 //
    //    const queryString = window.location.search;
    //    const urlParams = new URLSearchParams(queryString);
    //    const liff_state = urlParams.get('liff.state')
    //    if (liff_state)
    //    {
    ////      console.log("liff_state", liff_state);
    ////      window.location.replace(liff_state);
    ////      window.location.replace(decodeURI(liff_state));
    //      window.location.replace(liff_state);
    ////      window.location.href=liff_state;
    //    }
    //    // Modify By Bryant 2025041601 End //

    if (accessToken) {
      console.log("contains access token");
      if (!(await verifyLineAccessToken(accessToken))) {
        console.log("line access token expires");
        store.commit("line/setLineLoginData", {});
      }
    } else {
      console.log("no access token", lineLoginData);
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      if (code) {
        const state = params.get("state");
        try {
          await store.dispatch("line/getToken", { code, state });
        } catch (error) {
          const retryData = getLoginRetryData(state);
          if (!retryData) throw error;
          console.error(
            "line token failed, retry login without auto login",
            error
          );
          await lineLogin(retryData, { disableAutoLogin: true });
        }
      } else {
        throw new Error("Authorization code not found.");
      }
    }
  } catch (error) {
    // 登入失敗彈窗
    console.error("login error", error);
  } finally {
    next();
  }
};

export default homePageAuthGuard;
